import { Navigate, useParams } from "react-router-dom";
import { ReactNode } from "react";
import { useUsuarioPrefeitura } from "../../Hooks/UsuarioPrefeituraHook";
import { app_base_url } from "../../Utils/Urls";


type Props = {
  children: ReactNode;
};

export const BancoPrefeituraGuard = ({ children }: Props) => {
  const { banco } = useParams();
  const { usuarioPrefeitura } = useUsuarioPrefeitura();

  if (
    usuarioPrefeitura.usuario &&
    banco !== usuarioPrefeitura.entidade.banco
  ) {
    return (
      <Navigate
        to={`${app_base_url}/${usuarioPrefeitura.entidade.banco}/geral`}
        replace
      />
    );
  }

  return <>{children}</>;
};
